module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/181LGYD/tc-custom/9781452158198.jpg?1721656562325",
      "alt": "This image is the cover for the book Golden Book of Fortune-Telling, Fortune-Telling"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Golden Book of Fortune-Telling, Fortune-Telling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A compendium of fun and entertaining ways to understand your future, taken from entries in the bestselling Fortune-Telling series.")]), _c('br'), _c('br'), _vm._v("In this book lie the answers to your future. Reveal the meanings of your name, birthday, zodiac sign, and dreams. Unveil the significance of your color choices, friendships, and love interests. Discover what is foretold, learn to read auspicious omens, and divine the gift of attracting good fortune. Consult "), _c('i', [_vm._v("The Golden Book of Fortune-Telling")]), _vm._v(" and uncover the wisdom of the ages—and the power to shape your destiny.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      K.C. Jones\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0